export const ActionTypes = {
  START_ONBOARDING: 'START_ONBOARDING',
  FETCH_ONBOARDING: 'FETCH_ONBOARDING',
  FETCH_ONBOARDING_SUCCESS: 'FETCH_ONBOARDING_SUCCESS',
  UPDATE_STEP: 'UPDATE_STEP',
  FINISH_ONBOARDING: 'FINISH_ONBOARDING',
  CLEAR_ONBOARDING_CACHE: 'CLEAR_ONBOARDING_CACHE'
}